import Vue from 'vue'
import Router from 'vue-router'
import SLESForm from "@/components/SLESForm"
import Login from "@/components/Login"
import { isAuthenticated, deleteToken } from '@/utils/auth'

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: '/login',
            name: 'Login',
            component: Login,
            meta: {
                layout: 'login',
            },
        },
        {
            path: '/',
            name: 'Home',
            component: SLESForm,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/logout',
            name: 'Logout',
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.name === 'Login' && isAuthenticated()) {
        next({
            path: '/',
        });
    } else if (to.name === 'Logout') {
        if (isAuthenticated()) {
            deleteToken();
        }
        next(false);
        router.go({
            path: '/login',
        });
    } else if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!isAuthenticated()) {
            next({
                path: '/login',
                query: {redirect: to.fullPath},
            });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router
